<button class="btn agenda-btn"
        [class.is-selected]="isSelected"
        [class.is-ad-hoc]="agendaDetail.type === MeetingAgendaType.AdHoc"
        [class.is-system]="agendaDetail.type === MeetingAgendaType.System"
        [class.is-org]="agendaDetail.type === MeetingAgendaType.Organisation"
        [class.is-team]="agendaDetail.type === MeetingAgendaType.Team"
        (click)="onButtonClicked()">
    <span [attr.id]="meetingAgendaTemplateIdAttr">{{agendaDetail.meetingTemplate.name}}</span>
    <img *ngIf="agendaDetail.type === MeetingAgendaType.System"
         src="/content/shell/images/Adapt_Icon_Clementine_Outline.svg"
         adaptTooltip="This is a system-defined template" />
    <!-- dxhover* events are better which will work for tablet too - pointerenter/end not working properly for tablet -->
    <dx-popover [target]="'#' + meetingAgendaTemplateIdAttr"
                [showEvent]="{name: 'dxhoverstart', delay: 100}"
                [hideEvent]="{name: 'dxhoverend', delay: 250}"
                [(visible)]="popoverVisible"
                (onHiding)="onPopoverHiding($event)"
                [width]="250"
                height="auto"
                maxHeight="70vh">
        <div *dxTemplate="let data of 'content'"
             class="p-2"
             (pointerenter)="preventHide()"
             (pointerleave)="allowHide()"
             (pointerdown)="allowHide()">
            <div class="d-flex flex-column gap-2">
                @if (agendaDetail.meetingTemplate.meetingDescription) {
                    <div [froalaView]="agendaDetail.meetingTemplate.meetingDescription"></div>
                    <hr class="m-0" />
                }

                <div>
                    <h4 class="mb-1">Agenda items</h4>
                    <ul *adaptLoadingUntilFirstEmit="let items of agendaItems$"
                        class="list-content m-0">
                        @for (item of items; track item.meetingAgendaItemId) {
                            <li>{{item.name}}</li>
                        } @empty {
                            <li>No agenda items have been defined for this template.</li>
                        }
                    </ul>
                </div>
            </div>
        </div>
    </dx-popover>
</button>
